import { useState, useEffect, memo, useCallback, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { showSnackbarV2 } from '../../../../../../state/actions/notification';
import { getAuthData } from "../../../../../../services/storage/LocalStorage";
import { useStyles } from "../../../../../../assets/muiStyles";
import { RenderMenuCell } from "./RenderCell/renderMenuCell";
import { RenderCellContent } from "./RenderCell/renderCellContent";
import { RenderActionsCell } from "./RenderCell/renderActionsCell";
import config from "../../../../../../utils/config/config";
import { BotApiServices } from "../../../../../../services/api/BotApiServices";
import { StyledSyncIcon, StyledTableCell, StyledTableRow } from "./Styled";
import { UserServiceClientApi } from "../../../../../../services/api/UserApiServices";
import KeypadCallModal from "../../../../../ui/Modals/ModalMessages/KeypadCallModal";
import DiallerKeyPad from "../../../../../../pages/Telephony/Dialler/DiallerKeyPad";
import { makeCall } from "../../../../../../state/actions/phone";
import { isNil } from "lodash";
import { notifyInvalidPhone } from "../../../../../../pages/Telephony/components/Utils";
import { showToast } from "../../../../../ui/toaster";
import { RechargeContext } from "../../../../../../RechargeContext";


const ViewRowComponent = ({
    row,
    options,
    onSelectRow,
    selectedRow,
    handleAction,
    onRowMenuSelect,
    onlineStatus = 0,
    isSectionId,
    handleDeleteMenu,
    handleEditMenu,
    showCheckbox = false
}) => {

    const classes = useStyles();
    const [openDialPad, setOpenDialPad] = useState(false);
    const [isPostpaidUser, setIsPostpaidUser] = useState({});
    const [currentNumber, setCurrentNumber] = useState('');
    const user = useSelector((state) => state?.user);
    const chats = useSelector((state) => state?.chats);
    const userDomain = useSelector((state) => state?.selectedDomain?.userDomain);

    const selectedConversation = chats?.selectedConversation || {};
    const selectedConversationId = selectedConversation?.conversationId;
    const currentBotId = selectedConversation?.bot?.botId;
    const currentUserDomain = selectedConversation?.userDomain || '';
    const emailAddress = useSelector((state) => state.user?.user?.emailAddress);
    const balance = useSelector((state) => state.user.balance);

    const dispatch = useDispatch();
    const { user: { userTimezone } } = getAuthData();
    const defaultUserTimezone = "Etc/UTC";
    const postpaidStatus = useSelector((state) => state.user.voipStatus || false);
   const { openRecharge } = useContext(RechargeContext);

    const rowDataObject = Object.values(row || {})[0];    //get current row
    const rowOptions = rowDataObject?.rowOptions?.rowMenu != null &&
        Object.keys(rowDataObject?.rowOptions || {}).length > 0
        ? rowDataObject.rowOptions.rowMenu
        : options?.rowMenu;

    const isMainOtherMenu = options?.rowMenu;
    const newRowData = rowDataObject?.rowOptions;
    const isNewRow = newRowData?.hasOwnProperty("newRow");

    const hasRowOptions = rowOptions && rowOptions.length > 0;
    const hasMainOtherMenu = isMainOtherMenu && isMainOtherMenu.length > 0;

    useEffect(() => {
        if (postpaidStatus) {
            setIsPostpaidUser({ ...postpaidStatus });
        }
    }, [postpaidStatus]);

    const showCreateConversation = (phoneNumber) => {
        setOpenDialPad(true);
        phoneNumber = phoneNumber.replace(/ /g, "");
        setCurrentNumber(phoneNumber);
    };
    const showGetCreditModal = () => {
        if (openRecharge) {
            openRecharge();
        }
    };

    const handleOnAction = (action, label, column) => {
        const docId = Object.keys(row)[0];
        if (!row || !Object.values(row)[0]?.fields) {
            console.warn("Row format is invalid:", row);
            return;
        }

        const rowFormatted = {};
        Object.values(row)[0].fields.forEach((item) => {
            rowFormatted[item.id] = item.value;
        });
        row = rowFormatted;
        handleAction(action, { row: rowFormatted, selectedField: column?.id ?? "" }, null, docId
        );
    };


    const downloadFile = async (columnOptions) => {
        let scopeId = selectedConversationId;
        if (columnOptions?.fileScope === "bot") {
            scopeId = currentBotId;
        } else if (
            columnOptions?.fileScope === "domain") {
            scopeId = currentUserDomain;
        }
        else scopeId = selectedConversationId;

        if (user.isOnline) {
            const url = `${config.filesAPI}/downloadwithsignedurl/${columnOptions?.fileScope || "conversation"}/${scopeId}/${columnOptions?.value}`;
            console.log("Download file url:", url);

            try {
                const response = await BotApiServices.downloadSignedUrlFile(url);
                if (response?.status === 200 && response?.data?.signedUrl) {
                    const signedUrl = response.data.signedUrl;

                    try {
                        const fileResponse = await BotApiServices.downloadFile(signedUrl);

                        if (
                            fileResponse?.status === 200 &&
                            fileResponse?.data instanceof Blob
                        ) {
                            const blob = fileResponse.data;
                            const downloadUrl = window.URL.createObjectURL(blob);

                            const a = document.createElement("a");
                            a.href = downloadUrl;

                            // Default to fallback name if not available
                            a.download = columnOptions?.fileName || "downloaded-file";

                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            // Cleanup
                            window.URL.revokeObjectURL(downloadUrl);
                        } else {
                            throw new Error("Invalid blob response");
                        }
                    } catch (downloadError) {
                        console.error("Download file error:", downloadError);
                        dispatch(showSnackbarV2("error", "Failed to download file"));
                    }
                } else {
                    console.error("Signed URL not received:", response);
                    dispatch(showSnackbarV2("error", "Failed to generate signed URL"));
                }
            } catch (signedUrlError) {
                console.error("Error generating signed URL:", signedUrlError);
                dispatch(showSnackbarV2("error", "Failed to generate signed URL"));
            }
        } else {
            dispatch(
                showSnackbarV2(
                    "error",
                    "You will be able to download this file once you are back online"
                )
            );
        }
    };
    const closeCreateConversation = () => setOpenDialPad(false);

    const noBalance = () => {
        closeCreateConversation();
        showToast("error", "Insufficient balance");
        showGetCreditModal();
       
    };

    const makePhoneCall = useCallback(
        async (phone, callMode) => {
            if (isNil(phone)) {
                notifyInvalidPhone();
                return;
            }

            if (!isPostpaidUser.isPostpaidUser && balance <= 0) {
                noBalance();
                return;
            }

            const mode = callMode === "sat" ? "sat" : "phone";
            console.log('mode',mode)
            dispatch(
                makeCall(mode, emailAddress, phone, phone, null, null, "on-call")
            );
        },
        [isPostpaidUser, balance, emailAddress, dispatch]
    );

    return (
        <StyledTableRow
            isoffline={onlineStatus === 0 ? "true" : "false"}
            isSectionId={isSectionId}
        >
            <StyledTableCell padding="none" align="left">
                {onlineStatus === 2 && <StyledSyncIcon />}
            </StyledTableCell>

            {options.selectableRows && (
                <StyledTableCell>
                    <Checkbox
                        className={classes.customCheckbox}
                        checked={selectedRow?.some(
                            (item) => Object.keys(item)[0] === Object.keys(row)[0]
                        )}
                        onChange={(e) => onSelectRow(e, row)}
                    />
                </StyledTableCell>
            )}

            <RenderMenuCell
                isNewRow={isNewRow}
                hasRowOptions={hasRowOptions}
                hasMainOtherMenu={hasMainOtherMenu}
                onRowMenuSelect={onRowMenuSelect}
            />

            {options.actionableRows && (
                <StyledTableCell size="small">
                    <a
                        style={{ width: "25px" }}
                    // onClick={() => handleOnAction("onAction")}
                    >
                        <img
                            style={{ width: "25px" }}
                            src="./images/table-actions-menu.png"
                            alt="actionableRow"
                        />
                    </a>
                </StyledTableCell>
            )}

            {options?.columnNames &&
                Object.entries(options.columnNames)?.map(([key, value], i) => {
                    const column = Object.values(row)[0].fields?.find((field) => field.id === key);
                    return (
                        <StyledTableCell key={`${value}-${i}`}>
                            <RenderCellContent
                                row={row}
                                column={column}
                                options={options}
                                userDomain={userDomain}
                                userTimezone={userTimezone}
                                defaultUserTimezone={defaultUserTimezone}
                                handleAction={handleAction}
                                downloadFile={downloadFile}
                                handleOnAction={handleOnAction}
                                showCreateConversation={showCreateConversation}
                            />
                        </StyledTableCell>
                    );
                })}

            {/* Edit/Delete Actions */}
            {(options?.allowEdit || options?.allowDelete) &&
                (<RenderActionsCell
                    row={row}
                    allowEdit={options?.allowEdit}
                    allowDelete={options?.allowDelete}
                    handleEditMenu={handleEditMenu}
                    handleDeleteMenu={handleDeleteMenu}
                />)
            }
            {openDialPad && (
                <KeypadCallModal size="sm" noHeader className="dialler-modal p-0 overflow-hidden">
                    <DiallerKeyPad
                        makePhoneCall={makePhoneCall}
                        callerInfo={{ toNumber: currentNumber }}
                        onClose={closeCreateConversation}
                        noBalance={noBalance}
                    />
                </KeypadCallModal>
            )}
        </StyledTableRow>
    );
};

export default memo(ViewRowComponent);
